<template>
  <div class="company-page" :class="{ 'mobile': isMobile, 'desktop': !isMobile }">
    <h1>会社概要</h1>
    
    <dl>
      <dt>会社名</dt>
      <dd>メノア株式会社</dd>
      
      <dt>代表取締役</dt>
      <dd>吉川雄司、柿本竜也</dd>
      
      <dt>設立日</dt>
      <dd>2024年6月3日</dd>
      
      <dt>所在地</dt>
      <dd>〒150-0002<br>東京都渋谷区 渋谷1-1-3 アミーホール</dd>
      
      <dt>お問合せ先</dt>
      <dd>info@menoah.jp</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'CompanyView',
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    document.title = '会社概要 | メノア';
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    }
  }
};
</script>

<style scoped> 

/* 共通スタイル - 見出し設定 */
h1 {
  color: var(--color-green-600);
}

dt {
  font-weight: bold;
  font-size: 18px;
  color: var(--color-grey-500);
}

dd {
  font-size: 18px;
  color: var(--color-grey-500);
}

/* モバイル対応スタイル */
.mobile {
  padding-top: 56px;
  padding-bottom: 56px;
  padding-left: 24px;
  padding-right: 24px;
  }

.mobile h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: left;
}

.mobile dt {
  margin-top: 32px;
  font-size: 18px;
}

.mobile dd {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 32px;
  margin-top: 8px;
}

/* デスクトップ対応スタイル */
.desktop {
  padding-top: 120px;
  padding-bottom: 120px;
  padding-left: 80px;
  padding-right: 80px;
  max-width: 1120px;
  margin: 0 auto;
}

.desktop h1 {
  font-size: 28px;
  padding-bottom: 40px;
  text-align: left;
}

.desktop dt {
  margin-bottom: 8px;
  font-size: 18;
}

.desktop dd {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 32px;
}
</style>